import { graphql } from '@/gql';
import type { SendGroceryHistoryMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const sendGroceryHistory = async ({ phoneNumber, fromDate, toDate, emailAddress }: SendGroceryHistoryMutationVariables) => {
  const response = await mutationExecute({
    variables: {
      phoneNumber,
      fromDate,
      toDate,
      emailAddress,
    },
    mutation: graphql(`
      mutation SendGroceryHistory($phoneNumber: String!, $fromDate: String!, $toDate: String!, $emailAddress: String!) {
        sendGroceryHistory(phoneNumber: $phoneNumber, fromDate: $fromDate, toDate: $toDate, emailAddress: $emailAddress)
      }
    `),
  });

  return response.data?.sendGroceryHistory ?? '';
};
